import HtmlHelper from '../utils/HtmlHelper.js'
import Utils from "../utils/utils.js"

const utils_helper = new Utils()
const htmlHelper = new HtmlHelper()

export default class EditService {

    constructor(container_id) {
        this._ = null
        this.selected_element_selector = null
        this.selected_element_info = null
        this.hover_element_selector = null
        this.option = null
        this.oberserver = null
        this.is_edit_text = false
        this.container_id = container_id
    }

    initMethod() {
        let that = this
        const _ = {}
        _.querySelectorAll = document.querySelectorAll.bind(document)
        _.querySelector = document.querySelector.bind(document)
        _.getElementFromPoint = function(e) {
            const $overlay = document.getElementsByClassName('optimize99-ab-test-overlay')[0];
            $overlay.style.width = '0';
            const $element = document.elementFromPoint(e.clientX, e.clientY);
            $overlay.style.width = '';
            return $element;
        }
        _.getDomIndex = function(el){
            for (let ii = 0; ii < el.parentNode.children.length; ii++){
                if(el.parentNode.children[ii] === el){
                    return ii;
                }
            }
        }
        _.selector = function(targetElement) {
            var i = (targetElement.parentNode && 9 == targetElement.parentNode.nodeType) ? -1 : _.getDomIndex(targetElement);
            return targetElement.tagName.toLowerCase()
                + (~i ? ':nth-child(' + (i + 1) + ')' : '');
        };
        _.getDomSelector = function (element) {
            let path = utils_helper.unique(element)
            return path;
        }
        _.offset = function(itemEl) {
            if (!itemEl) return;
            const rect = itemEl.getBoundingClientRect();
            if ( rect.width || rect.height ) {
                const doc = itemEl.ownerDocument;
                const docElem = doc.documentElement;
                // 兼容IE写法 ==》  - docElem.clientTop、 - docElem.clientLeft ，其它浏览器为0px，IE为2px
                return {
                    top: rect.top + window.pageYOffset - docElem.clientTop,
                    left: rect.left + window.pageXOffset - docElem.clientLeft,
                };
            }else{
                return {
                    top: 0,
                    left: 0
                }
            }
        };
        _.getSize = function(itemEl) {
            if (!itemEl) return;
            if (!window.getComputedStyle) {
                return {width: itemEl.offsetWidth, height: itemEl.offsetHeight};
            }
            try {
                const bounds = itemEl.getBoundingClientRect();
                return {width: bounds.width, height: bounds.height};
            } catch (e){
                return {width: 0, height: 0};
            }
        };
        _.getStyle = function(itemEl, cssKey) {
            // 若可以拿到 style上的属性，则取它
            if(itemEl.style[cssKey]) {
                return itemEl.style[cssKey];
            }
            // 兼容IE
            if(itemEl.currentStyle){
                return itemEl.currentStyle[cssKey];
            }else{
                return itemEl.ownerDocument.defaultView.getComputedStyle(itemEl, null).getPropertyValue(cssKey);
            }
        };
        _.getElementSpacingOffset = function(direction) {
            const $html = document.getElementsByTagName('html')[0];
            const $body = document.getElementsByTagName('body')[0];
            const scroll = (direction === 'top' ? window.scrollY : window.scrollX);
            const htmlPadding = parseInt(_.getStyle($html, 'padding-' + direction));
            const htmlMargin = parseInt(_.getStyle($html, 'margin-' + direction));
            const htmlBorder = parseInt(_.getStyle($html, 'border-' + direction));
            const bodyBorder = parseInt(_.getStyle($body, 'border-' + direction));
            let a = 0;
            if (htmlBorder > 0 && bodyBorder > 0) {
                a = htmlBorder + bodyBorder;
            }
            return parseInt(htmlPadding + htmlMargin + scroll + a, 10);
        };
        _.setOverlayPropertiesForElement = function(originEl, targetEl) {
            const offset = _.offset(originEl);
            const getSize = _.getSize(originEl);
            const elementBounds = {
                bottom: offset.top + getSize.height,
                top: offset.top,
                left: offset.left,
                right: offset.left + getSize.width,
                width: getSize.width,
                height: getSize.height
            };
            const setOverlayPropertiesForElementLeft = _.getElementSpacingOffset('left') + 1;
            const setOverlayPropertiesForElementTop = _.getElementSpacingOffset('top') + 1;
            targetEl.style.top = (elementBounds.top - setOverlayPropertiesForElementTop)  + 'px';
            targetEl.style.left = (elementBounds.left - setOverlayPropertiesForElementLeft)  + 'px';
            targetEl.style.width = elementBounds.width + 'px';
            targetEl.style.height = elementBounds.height + 'px';
        };
        const types = {
            'hover': 'optimize99-abtest-hover',
            'selected': 'optimize99-abtest-selected'
        };
        _.highlight = function(e) {
            const selector = e.selector || '';
            const $elArr = _.querySelectorAll(selector);
            for(let i = 0; i < $elArr.length; i += 1) {
                let exist_div = document.querySelector('.' + types[e.type])
                let $div = document.createElement('div');
                if (exist_div) {
                    $div = exist_div
                }
                $div.className = 'optimize99-abtest-cursor ' + types[e.type];
                document.body.insertBefore($div, _.querySelector('.optimize99-abtest-page-overlay'));
                //设置元素蒙层的样式，width、height、left、top
                _.setOverlayPropertiesForElement($elArr[i], $div);
            }
        };
        _.rerender = function() {
            // console.log('re')
            if (that.selected_element_selector) {
                const $optimize99AbtestCursorSelected = _.querySelector('div.optimize99-abtest-selected');
                let selectedElement = _.querySelector(that.selected_element_selector)
                if ($optimize99AbtestCursorSelected) {
                    _.setOverlayPropertiesForElement(selectedElement, $optimize99AbtestCursorSelected);
                }
            }

            if (that.hover_element_selector) {
                const $optimize99AbtestCursorHovered = _.querySelector('div.optimize99-abtest-hover')
                let hoveredElement = _.querySelector(that.hover_element_selector)
                if ($optimize99AbtestCursorHovered) {
                    _.setOverlayPropertiesForElement(hoveredElement, $optimize99AbtestCursorHovered);
                }
            }



        };
        _.getElementInfo = function(itemEl) {
            if (!itemEl) {
            return null;
            }
            const obj = {
                nodeName: itemEl.nodeName,
                parentNodeName: itemEl.parentNode.nodeName,
                parentSelector: _.getDomSelector(itemEl.parentElement),
                parentOuterHTML: itemEl.parentElement.outerHTML,
                innerHtml: itemEl.innerHTML,
                outerHtml: itemEl.outerHTML,
                css: {},
                attributes: {}
            };
            // 取樣式
            Object.keys(that.option.css_mapper).forEach(function(css_group_name){
                Object.keys(that.option.css_mapper[css_group_name]).forEach(function(css_name){
                    obj.css[css_name] = _.getStyle(itemEl, css_name)
                })
            })

            // 取屬性
            Object.keys(that.option.attribute_mapper).forEach(function(attribute_name){
                let attribute_val = itemEl.getAttribute(attribute_name)
                if (attribute_val) {
                    obj.attributes[attribute_name] = attribute_val
                }
                // obj.attributes[attribute_name] = itemEl.getAttribute('src');
            })

            return obj;
        };
        this._ = _
    }

    async start(option){
        console.log('進service')
        this.option = option
        this.initMethod()

        try {
            if (!window.is_opt99_anmation_loaded) {
                await htmlHelper.loadAnimationResources(true)
            }
        } catch (error) {
            console.log('load-error', error)
        }

        let that = this
        // 插入蒙版
        let overlay_css = `
            .optimize99-ab-test-overlay {
                background: transparent;
                display: block;
                position: fixed;
                right: 0px;
                top: 0px;
                width: 100%;
                height: 100%;
                margin: 0 !important;
                padding: 0 !important;
                z-index: 2147483647 !important;
            }
            .optimize99-ab-test-internal-overlay{
                position: fixed; 
                padding: 0px; 
                margin: 0px; 
                background-color: rgba(0, 0, 0, 0.4);
                z-index: 2147483647 !important;
                display:none;
            }
        `
        overlay_css += `
            .optimize99-abtest-cursor {
                position: fixed; 
                z-index: 2147483647 !important;
                pointer-events: none;
                border-radius: 2px;
                box-sizing: content-box;
                margin: 0 !important;
                padding: 0 !important; 
            }
            .optimize99-abtest-selected {
                border: 2px solid rgba(0, 107, 255, 1); 
            }
            .optimize99-abtest-hover {
                border: 2px solid rgba(0, 107, 255, 0.5); 
            }
        `
        let style = document.createElement('style');
        document.head.appendChild(style);
        style.type = 'text/css';
        style.appendChild(document.createTextNode(overlay_css));
        console.log('document', document)
        console.log('style', style)

        // 蒙版
        const overlay = document.createElement('optimize99-ab-test-overlay');
        overlay.className = 'optimize99-ab-test-overlay';
        document.body.append(overlay);

        // 編輯模式的蒙版
        const edit_text_overlay = document.createElement('optimize99-ab-test-internal-overlay');
        edit_text_overlay.className = 'optimize99-ab-test-internal-overlay'
        let top_overlay = edit_text_overlay.cloneNode(true);
        let right_overlay = edit_text_overlay.cloneNode(true);
        let bottom_overlay = edit_text_overlay.cloneNode(true);
        let left_overlay = edit_text_overlay.cloneNode(true);
        document.body.append(top_overlay);
        document.body.append(right_overlay);
        document.body.append(bottom_overlay);
        document.body.append(left_overlay);
        console.log('is_edit_text',this.is_edit_text)
        const handleEvent = function(e) {
            // console.log('is_edit_text',that.is_edit_text)
            if (!that.is_edit_text) {
                const closest_link = e.target.closest('a')
                if (!closest_link) {
                    e.stopImmediatePropagation();
                    e.stopPropagation();
                }

                if (e.type === "contextmenu") {
                    console.log('click-2')
                    return false;
                }

                if (e.type === 'click') {
                    console.log('click-3')
                    that.handleClick(e);
                    return false
                }

                if (e.type === 'mousemove') {
                    // console.log('wwww')
                    that.handleMouseOver(e)
                    return false
                }
            }
            else {
                let ignore_eles = [
                    '.minify-popup'
                ]
                let is_pass = false
                for (let idx = 0;idx <ignore_eles.length; idx++) {
                    let ignore_ele = e.target.closest(ignore_eles[idx])
                    if (ignore_ele) {
                        is_pass = true
                        break
                    }
                }

                if (!is_pass) {
                    e.stopImmediatePropagation();
                    e.stopPropagation();
                    return false
                }
            }


        };
        document.body.addEventListener("click", handleEvent, true);
        document.body.addEventListener("contextmenu", handleEvent, true);
        document.body.addEventListener('mousemove', handleEvent, true);
        window.addEventListener('resize', () => {
            setTimeout(function(){
                that._.rerender()
                if (that.is_edit_text) {
                    that.resizeEditOverlay()
                }
            }, 50);
        });
        window.addEventListener('scroll', () => {
            setTimeout(function(){
                that._.rerender()
                if (that.is_edit_text) {
                    that.resizeEditOverlay()
                }
            }, 50);
        });
        let links = Array.from(document.querySelectorAll('a'))
        links.forEach(function(link){
            link.addEventListener('click', that.disableHref)
        })

        // 針對封鎖右鍵處理
        document.addEventListener('selectstart', function(event) {
            event.stopPropagation();
        }, true);

        const elementsWithStyle = document.querySelectorAll('[style]');

        elementsWithStyle.forEach(el => {
            const userSelect = el.style.userSelect;
            const webkitUserSelect = el.style.webkitUserSelect;

            if (userSelect === 'none' || webkitUserSelect === 'none') {
                el.style.userSelect = '';
                el.style.webkitUserSelect = '';
            }
        });

        const styleSheets = document.styleSheets;
        for (let i = 0; i < styleSheets.length; i++) {
            const styleSheet = styleSheets[i];
            try {
                const rules = styleSheet.cssRules || styleSheet.rules;
                for (let j = 0; j < rules.length; j++) {
                const rule = rules[j];
                if (rule.style && (rule.style.userSelect === 'none' || rule.style.webkitUserSelect === 'none')) {
                    rule.style.userSelect = '';
                    rule.style.webkitUserSelect = '';
                }
                }
            } catch (e) {
                console.log(e);
            }
        }

        parent.postMessage({
            'action': 'edit_mode_init_done',
            'container_id': this.container_id
        }, '*')

    }

    handleClick(e, target_selector, platform_step, step_type, is_by_step, update_result) {
        let that = this
        let editor_type = ''
        let plugin_vid = ''
        let plugin_id = ''
        let current_vid = ''
        let plugin_type = ''
        let plugin_param = {}
        let $element = ''
        let back_history = ''
        if (e) {
            $element = this._.getElementFromPoint(e);
        }
        else {
            if (typeof(target_selector) !== 'string') {
                $element = this._.querySelector(target_selector.selector)
                back_history = target_selector
            }
            else {
                $element = this._.querySelector(target_selector)
            }

        }

        // 檢查是不是插件
        let plugin_ele = $element.closest('[opt99-plugin]');
        console.log('plugin_ele:', plugin_ele)
        if (plugin_ele) {
            plugin_vid = plugin_ele.getAttribute('opt99-vid')
            plugin_id = plugin_ele.getAttribute('opt99-id')
            plugin_type = plugin_ele.getAttribute('opt99-plugin')
            let current_url = new URL(window.location.href)
            current_vid = current_url.searchParams.get('vid')
            let bypass_plugins = ['animation']
            if (current_vid === plugin_vid || bypass_plugins.includes(plugin_type)) {
                $element = plugin_ele
                editor_type = 'plugin'
                
                let settings = []
                switch (plugin_type) {
                    case 'online_user':
                        settings = [
                            {
                                name: 'plugin_setting',
                                selector: '',
                                attribute_fields: [],
                                css_fields: ['justify-content','text-align','margin-top', 'margin-bottom'],
                                value_fields: []
                            },
                            {
                                name: 'basic_setting',
                                selector: '[name="container"]',
                                attribute_fields: ["opt99-id", 'opt99-top', 'opt99-bot', 'opt99-value', 'opt99-is_interval_count'],
                                css_fields: ['width','height', 'background-color', 'justify-content'],
                                value_fields: []
                            },
                            {
                                name: 'icon_style_setting',
                                selector: '[name="icon"]',
                                attribute_fields: [],
                                css_fields: ['width' ,'height', 'color', 'font-size'],
                                value_fields: ['innerText']
                            },
                            {
                                name: 'start_text_style_setting',
                                selector: '[name="start_description"]',
                                attribute_fields: [],
                                css_fields: ['width' ,'height', 'color', 'font-size'],
                                value_fields: ['innerText']
                            },
                            {
                                name: 'end_text_style_setting',
                                selector: '[name="end_description"]',
                                attribute_fields: [],
                                css_fields: ['width' ,'height', 'color', 'font-size'],
                                value_fields: ['innerText']
                            },
                            {
                                name: 'couter_text_style_setting',
                                selector: '[name="counter"]',
                                attribute_fields: [],
                                css_fields: ['width' ,'height', 'color', 'font-size'],
                                value_fields: ['innerText']
                            },
                        ]
                        break;
                    case 'sales_counter':
                        settings = [
                            {
                                name: 'plugin_setting',
                                selector: '',
                                attribute_fields: [],
                                css_fields: ['justify-content','margin-top', 'margin-bottom'],
                                value_fields: []
                            },
                            {
                                name: 'basic_setting',
                                selector: '[name="container"]',
                                attribute_fields: [
                                    "opt99-id", 'cal_type', 'multiple', 'init', 'loop', 'repeat_from', 'top'],
                                css_fields: ['width','height', 'background-color'],
                                value_fields: []
                            },
                            {
                                name: 'start_text_style_setting',
                                selector: '[name="start_description"]',
                                attribute_fields: [],
                                css_fields: ['width' ,'height', 'color', 'font-size'],
                                value_fields: ['innerText']
                            },
                            {
                                name: 'end_text_style_setting',
                                selector: '[name="end_description"]',
                                attribute_fields: [],
                                css_fields: ['width' ,'height', 'color', 'font-size'],
                                value_fields: ['innerText']
                            },
                            {
                                name: 'couter_text_style_setting',
                                selector: '[name="counter"]',
                                attribute_fields: [],
                                css_fields: ['width' ,'height', 'color', 'font-size'],
                                value_fields: ['innerText']
                            },
                        ]
                        break;
                    case 'ba_slider':
                        settings = [
                            {
                                name: 'basic_setting',
                                selector: '[name="container"]',
                                attribute_fields: [
                                    "opt99-id", 'start_percent', 'direction'
                                ],
                                css_fields: [],
                                value_fields: [],
                            },
                            {
                                name: "after_img_setting",
                                selector: 'div[name="container"] > div[name="slider-new"] > img',
                                css_fields: [],
                                value_fields: [],
                                attribute_fields: [
                                    "src"
                                ],
                            }
                        ]
                        break;

                    case 'animation':
                        settings = [
                            {
                                name: 'base',
                                selector: '[animation-bg]',
                                attribute_fields: [
                                    'src', 'data-aos', 'data-aos-delay', 'data-aos-once' , 'data-keep-animation', 'data-mix-blend-mode'
                                ],
                                css_fields: [],
                                value_fields: [],
                            },
                            {
                                name: 'layers',
                                selector: '[animation-thing]',
                                is_plural: true,
                                attribute_fields: [
                                    'src', 'data-aos', 'data-aos-delay', 'data-aos-once' , 'data-keep-animation', 'animation-thing-key', 'data-mix-blend-mode', 'data-layer-name'
                                ],
                                css_fields: [
                                    'width', 'top', 'left', 'display', 'z-index'
                                ],
                                value_fields: [],
                            },
                        ]
                        break
                    default:
                        editor_type = ''
                        plugin_type = ''
                }

                settings.forEach(function(setting){
                    if (setting.is_plural) {
                        plugin_param[setting.name] = that.getPluginParamMulti(
                            $element, setting.selector,
                            setting.attribute_fields,
                            setting.css_fields,
                            setting.value_fields,
                        )
                    }
                    else {
                        plugin_param[setting.name] = that.getPluginParam(
                            $element, setting.selector,
                            setting.attribute_fields,
                            setting.css_fields,
                            setting.value_fields,
                        )
                    }

                })
            }
        }


        let selector = this._.getDomSelector($element);
        if (editor_type === 'plugin') {
            if (plugin_type === 'animation') {
                selector = `[opt99-plugin="${plugin_type}"][opt99-id="${plugin_id}"]`
            }
            else {
                selector = `[opt99-plugin="${plugin_type}"][opt99-vid="${plugin_vid}"][opt99-id="${plugin_id}"]`
            }
        }
        console.log(selector)

        const ele_info = this._.getElementInfo($element)
        console.log(ele_info)

        this.selected_element_selector = selector
        this.selected_element_info = ele_info

        let ele = {
            selector: selector,
            type: 'selected'
        }
        this._.highlight(ele);

        const action = {
            action: 'selected',
            data: {
                selected_element_selector: selector,
                selected_element_info: ele_info,
                editor_type: editor_type,
                plugin_type: plugin_type,
                plugin_param: plugin_param,
                back_history: back_history,
                el_pageY: e?.pageY ?? null,
                data_sort_id: $element.getAttribute('data-sort-id'),
                platform_step: platform_step ? platform_step : '',
                is_need_update_history: false,
                update_result: update_result
            },
        }

        //TODO: 先這樣
        if (!platform_step && $element.closest('[data-id^="carousel"]')) {
            const choose_carousels_id = $element.closest('[data-id^="carousel"]').getAttribute('data-id')
            action.data.carousel_data = window.carousels[choose_carousels_id].getCarouselData()
            action.data.carousel_data.selector = window.carousels[choose_carousels_id].create_selector
        }

        if (platform_step) {
            let need_callback_update_history_method = [
                'remove_animation', 'sort_element', 'carousel'
            ]
            if (need_callback_update_history_method.includes(platform_step.type)) {
                console.log('step_type', step_type)
                console.log('is_by_step', is_by_step)
                if (step_type !== 'previous') {
                    if (!is_by_step) {
                        action.data.is_need_update_history = true
                    }
                }
                else {
                    if (is_by_step && platform_step.type !== 'remove_animation') {
                        action.data.is_need_update_history = true
                    }
                }
            }
        }

        if (platform_step && platform_step.type === 'css') {
            try {
                delete action.data.selected_element_info.parentOuterHTML
            } catch (error) {
                console.error('delete_back_info_error', error)
            }
            
        }

        console.log('送更新更新更新')
        parent.postMessage(action, '*');
    }

    handleMouseOver(e){
        const $element = this._.getElementFromPoint(e);
        // console.log($element)
        const selector = this._.getDomSelector($element);
        // console.log(selector)

        this.hover_element_selector = selector

        let ele = {
            selector: selector,
            type: 'hover'
        }
        this._.highlight(ele);
    }

    disableHref(event){
        console.log('點到摟', event)
        event.preventDefault();
        event.stopPropagation();
    }
    // type 是 next 還是 previous(上下一步)
    async updateElement(data, type, vid, is_by_step){
        // console.log('-------sdk update ele-------', vid)
        let update_result = await htmlHelper.updateSelectedElement(document, data, type, vid, 'platform', is_by_step)
        if (!update_result.selector) {
            console.log('找不到ELE')
            return
        }
        // update_result = update_result.selector

        console.log('update_result:', update_result)
        if (!data.is_load_history) {
            this.handleClick(null, update_result.selector, data, type, is_by_step, update_result)
        }
        return
        // 高光修改的元素
        let ele = {
            selector: data.selector,
            type: 'selected'
        }
        console.log(this._)
        this._.highlight(ele);

        // // 更新editor內容
        const $element = this._.querySelector(data.selector)

        const selector = this._.getDomSelector($element);
        // console.log(selector)

        const ele_info = this._.getElementInfo($element)
        // console.log(ele_info)

        this.selected_element_selector = selector
        this.selected_element_info = ele_info

        const action = {
            action: 'selected',
            data: {
                css: data.css,
                selected_element_selector: selector,
                selected_element_info: ele_info
            }
        }
        parent.postMessage(action, '*');

    }

    sortElement(data){
        this.updateElement(data.payload, data.type, data.vid, data.is_by_step)
        // moveElement(data)
    }

    getElementInfo(selector, method){
        // // 更新editor內容
        const $element = this._.querySelector(selector)
        // console.log(selector)

        const ele_info = this._.getElementInfo($element)

        const action = {
            action: 'get_element_info',
            data: {
                selected_element_selector: selector,
                selected_element_info: ele_info,
                method: method
            }
        }
        parent.postMessage(action, '*');
    }

    editText(edit_data){
        console.log('編輯模式！', edit_data.is_edit_text)
        this.is_edit_text = edit_data.is_edit
        let is_edit_text = edit_data.is_edit
        let that = this
        const overlay = this._.querySelector('.optimize99-ab-test-overlay')
        const hover_overlay = this._.querySelector('.optimize99-abtest-hover')
        const selected_overlay = this._.querySelector('.optimize99-abtest-selected')
        const internal_overlays = Array.from(this._.querySelectorAll('.optimize99-ab-test-internal-overlay'))
        const $element = this._.querySelector(this.selected_element_selector)

        if (is_edit_text === true) {

            console.log('編輯模式')
            this.resizeEditOverlay()
            if (edit_data.contenteditable) {
                $element.setAttribute('contenteditable', true)
            }


            // overlay隱藏
            overlay.style.display = 'none'
            // 外框隱藏
            hover_overlay.style.display = 'none'
            // hover外框隱藏
            if (selected_overlay) {
                selected_overlay.style.display = 'none'
            }

            // 顯示上下左右的overlay
            internal_overlays.forEach(function(internal_overlay){
                internal_overlay.style.display = 'block'
            })

            this.oberserver = new MutationObserver(() => {
                console.log('Content changed');
                that.resizeEditOverlay()
            });

           this.oberserver.observe($element, {
                childList: true,
                subtree: true,
                characterData: true,
            });
        }
        else {
            console.log('取消編輯模式')
            if ($element) {
                $element.removeAttribute('contenteditable')
            }
            

            // 蒙版顯示回來
            overlay.style.display = 'block'

            // hover的外框顯示回來
            hover_overlay.style.display = 'block'

            // selected的外框顯示回來
            if (selected_overlay) {
                selected_overlay.style.display = 'block'
            }
            // 隱藏上下左右的overlay
            internal_overlays.forEach(function(internal_overlay){
                internal_overlay.style.display = 'none'
            })

            this.oberserver?.disconnect();
            this.oberserver = null
        }

    }

    resizeEditOverlay(){
        if (!this.selected_element_selector) {
            return
        }
        const $element = this._.querySelector(this.selected_element_selector)
        const offset = this._.offset($element)
        const getSize = this._.getSize($element);
        const docWidth = $element.ownerDocument.documentElement.clientWidth
        const docHeight = $element.ownerDocument.documentElement.clientHeight
        const setOverlayPropertiesForElementLeft = this. _.getElementSpacingOffset('left') + 1;
        const setOverlayPropertiesForElementTop = this._.getElementSpacingOffset('top') + 1;
        const elementBounds = {
            bottom: offset.top + getSize.height,
            top: offset.top - setOverlayPropertiesForElementTop,
            left: offset.left - setOverlayPropertiesForElementLeft,
            right: offset.left + getSize.width,
            width: getSize.width,
            height: getSize.height
        };

        // 上
        const top_overlay = $element.ownerDocument.documentElement.getElementsByClassName('optimize99-ab-test-internal-overlay')[0]
        if (top_overlay) {
            top_overlay.style.top = '0px'
            top_overlay.style.width = '100%'

            if (elementBounds.top <= 0) {
                top_overlay.style.height = '0px'
            }
            else {
                top_overlay.style.height = elementBounds.top + 'px'
            }

        }

        // 右
        const right_overlay = $element.ownerDocument.documentElement.getElementsByClassName('optimize99-ab-test-internal-overlay')[1]
        if (right_overlay) {
            right_overlay.style.right = '0px'
            right_overlay.style.top = elementBounds.top + 'px'
            right_overlay.style.width = docWidth - elementBounds.right - 2 + 'px'
            right_overlay.style.height = elementBounds.height + 'px'
        }

        // 下
        const bottom_overlay = $element.ownerDocument.documentElement.getElementsByClassName('optimize99-ab-test-internal-overlay')[2]
        if (bottom_overlay) {
            bottom_overlay.style.bottom = '0px'
            if (docHeight - (elementBounds.top + elementBounds.height) <= 0) {
                bottom_overlay.style.height = 0
            }
            else {
                bottom_overlay.style.height = docHeight - (elementBounds.top + elementBounds.height) + 'px'
            }
            bottom_overlay.style.width = '100%'
        }

        // 左
        const left_overlay = $element.ownerDocument.documentElement.getElementsByClassName('optimize99-ab-test-internal-overlay')[3]
        if (left_overlay) {
            left_overlay.style.left = '0px'
            left_overlay.style.top = elementBounds.top + 'px'
            left_overlay.style.width = elementBounds.left + 'px'
            left_overlay.style.height = elementBounds.height + 'px'
        }
    }

    getPluginParam(base_ele, ele_selector, attribute_fields, css_fields, value_fields){
        let param_ele = base_ele
        if (ele_selector) {
            param_ele = base_ele.querySelector(ele_selector)
        }
        console.log('param_ele', param_ele)
        let param_css_info = this._.getElementInfo(param_ele)
        console.log('param_css_info', param_css_info)
        let param = {
            attribute: {},
            css: {},
            value: {},
        }
        attribute_fields.forEach(function(attribute_field){
            param['attribute'][attribute_field] = param_ele.getAttribute(attribute_field)
        })
        css_fields.forEach(function(css_name){
            param['css'][css_name] = param_css_info.css[css_name]
        })
        value_fields.forEach(function(value_field){
            param['value'][value_field] = param_ele[value_field]
        })

        return param

    }

    actionToPage(data){
        console.log('edit-actionToPage', data)
        switch (data.event) {
            case 'overlay':
                this.displayOverlay(data.value, data.mode, data.is_lock_click)
                break;
            case 'editAnimation':
                this.editAnimation()
                break;
            case 'closeHightLightBorder':
                let animation_wrappers = Array.from(document.querySelectorAll('[opt99-plugin="animation"]'))
                animation_wrappers.forEach(animation_wrapper => {
                    let interact_eles = Array.from(animation_wrapper.querySelectorAll('[data-layer-interact]'))
                    interact_eles.forEach(interact_ele => {
                        interact_ele.removeAttribute('data-layer-interact')
                        if (interact) {
                            interact(interact_ele).unset()
                        }  
                    })
                })
                break;
            default:
                console.log('action-not-hit')
        }
    }

    getPluginParamMulti(base_ele, ele_selector, attribute_fields, css_fields, value_fields){
        let param_eles = Array.from(base_ele.querySelectorAll(ele_selector))
        console.log('param_ele', param_eles)

        let results = param_eles.map(param_ele => {
            let param_css_info = this._.getElementInfo(param_ele)
            console.log('param_css_info', param_css_info)
            let param = {
                attribute: {},
                css: {},
                value: {},
            }
            attribute_fields.forEach(function(attribute_field){
                param['attribute'][attribute_field] = param_ele.getAttribute(attribute_field)
            })
            css_fields.forEach(function(css_name){
                param['css'][css_name] = param_css_info.css[css_name]
            })
            value_fields.forEach(function(value_field){
                param['value'][value_field] = param_ele[value_field]
            })
            return param
        })
        return results
    }

    displayOverlay(is_display, mode, is_lock_click){
        this.is_edit_text = is_lock_click
        const overlay = this._.querySelector('.optimize99-ab-test-overlay')
        const hover_overlay = this._.querySelector('.optimize99-abtest-hover')
        const selected_overlay = this._.querySelector('.optimize99-abtest-selected')
        const internal_overlays = Array.from(this._.querySelectorAll('.optimize99-ab-test-internal-overlay'))
        if (!is_display) {
            // overlay隱藏
            overlay.style.display = 'none'
            // hover外框隱藏
            hover_overlay.style.display = 'none'
            // 選取外框隱藏
            if (selected_overlay && mode === 'interactor') {
                selected_overlay.style.display = 'none'
            }

            internal_overlays.forEach(function(internal_overlay){
                internal_overlay.style.display = 'none'
            })
        }
        else {
            // overlay隱藏
            overlay.style.display = 'block'
            // hover外框隱藏
            hover_overlay.style.display = 'block'
            // 選取外框隱藏
            if (selected_overlay && mode === 'interactor') {
                selected_overlay.style.display = 'none'
            }
        }
    }

    async carousel(post_msg){
        await this.updateElement(post_msg.payload, post_msg.type, post_msg.vid)
    }
}
